module.exports = __webpack_public_path__ + "img/ogp_balamboo_big.ba7d4abf.jpg";